// ClientsPage.jsx

// Dependencies
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import Clients from '@/components/data/clients/Clients';
import PageHeading from '@/components/common/PageHeading';
import LoadingOverlay from '@/components/common/LoadingOverlay';

// Services
import { getClients } from '@/services/schedulingService';

const ClientsPage = () => {
  const { t } = useTranslation();

  const [clients, setClients] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const clients = await getClients();
        setClients(clients);
      } catch (error) {
        console.error('Error fetching clients data:', error);
        setClients([
          {
            ClientID: '1',
            ClientCode: 'BBC',
            Client: 'British Broadcasting Corporation',
            Alias: 'British',
            EngagementID: '201',
            EngagementName: 'BBC - Documentary',
            EngagementAlias: 'BBC'
          },
          {
            ClientID: '2',
            ClientCode: 'BBC',
            Client: 'British Broadcasting Corporation',
            Alias: 'British',
            EngagementID: '202',
            EngagementName: 'BBC - News',
            EngagementAlias: 'BBC-News'
          }
        ]);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  const filteredClients = clients || [];

  return (
    <div className='workspace-management-page'>
      {loading && <LoadingOverlay />}
      <PageHeading title='Clients' />
      <div>{filteredClients && <Clients clients={filteredClients} />}</div>
    </div>
  );
};

export default ClientsPage;
